/**
 * Category hero images for the Montessori-koulu learning hub.
 * Used by the hub index (article cards) and by BlogPost as the
 * default article hero when a post doesn't define its own image.
 */
import perusteet from "@/assets/hub/perusteet.jpg";
import vauva from "@/assets/hub/vauva.jpg";
import taapero from "@/assets/hub/taapero.jpg";
import itsenaisyys from "@/assets/hub/itsenaisyys.jpg";
import koti from "@/assets/hub/koti.jpg";
import motoriikka from "@/assets/hub/motoriikka.jpg";
import vanhemmanOpas from "@/assets/hub/vanhemman-opas.jpg";

import type { CategoryId } from "./montessori-koulu-posts";

export const CATEGORY_HERO: Record<CategoryId, string> = {
  perusteet,
  vauva,
  taapero,
  itsenaisyys,
  koti,
  motoriikka,
  "vanhemman-opas": vanhemmanOpas,
};

import digiaika from "@/assets/hub/liike-digiaika.jpg";
import suomessa2026 from "@/assets/hub/montessori-suomessa-2026.jpg";
import nordic2026 from "@/assets/hub/nordic-montessori-2026.jpg";
import { POSTS } from "./montessori-koulu-posts";

/** Article-specific heroes (override the category default). */
export const ARTICLE_HERO: Record<string, string> = {
  "lapsuus-muuttuu-digiaika": digiaika,
  "montessori-suomessa-2026": suomessa2026,
  "nordic-montessori-konferenssi-2026": nordic2026,
};

/** Hero image for an article slug — article-specific first, category fallback. */
export function articleHeroFor(slug: string): string {
  const own = ARTICLE_HERO[slug];
  if (own) return own;
  const post = POSTS.find((p) => p.slug === slug);
  return CATEGORY_HERO[post?.category ?? "perusteet"];
}
